module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.exists) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-tra"
  }, [_c('div', {
    staticClass: "msg-order"
  }, [(_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title-nf"
  }, [_vm._v("\n            No hemos podido encontrar tu pedido\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "p-nf"
  }, [_vm._v("\n            Comunicate con nosotros para brindarte información de tu pedido\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ora",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "click": function($event) {
        return _vm.contact()
      }
    }
  }, [_vm._v("Contáctate con nosotros")])]), _vm._v(" "), (!_vm.mobile) ? _c('div', [_c('img', {
    staticClass: "img-nf",
    attrs: {
      "src": "/static/img/noencontrado.png"
    }
  })]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47306e3d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tracking/Tracking.vue
// module id = 514
// module chunks = 1